import { AI_MODELING_EFFECT_MAX_ELEMENTS } from './aiModelingEffectTiming';

type SourceElement = { id: string };

export type AIModelingEffectSource = {
  nodes?: SourceElement[];
  zones?: SourceElement[];
  links?: SourceElement[];
  descriptionPanels?: SourceElement[];
};

/** 適用した編集内容から、出現アニメーションの対象になる要素IDを集める。 */
export function collectAIModelingEffectElementIds(views: readonly AIModelingEffectSource[]): string[] {
  return views
    .flatMap((view) => [
      ...(view.zones ?? []),
      ...(view.nodes ?? []),
      ...(view.links ?? []),
      ...(view.descriptionPanels ?? []),
    ])
    .map((element) => element.id)
    .slice(0, AI_MODELING_EFFECT_MAX_ELEMENTS);
}
